import { AnyProductType } from "types";

export const getShoppingCart = (state) => state.cart as AnyProductType[];
